/** Determina si el parametro es null */
export function isNull(value: any) {
    return value === null;
}

/** Determina si el parametro es undefined */
export function isUndefined(value: any) {
    return value === undefined;
}

/** Determina si el parametro es null o undefined */
export function isNullOrUndefined(value: any) {
  return isNull(value) || isUndefined(value);
}

/** Determina si el parametro NO es null */
export function isNotNull(value: any) {
    return value !== null;
}

/** Determina si el parametro NO es undefined */
export function isNotUndefined(value: any) {
    return value !== undefined;
}

/** Determina si el parametro NO es null NI undefined */
export function isNotNullOrUndefined(value: any) {
    return isNotNull(value) && isNotUndefined(value);
}

/** Alias para `isNotNullOrUndefined()` */
export const isDefined = isNotNullOrUndefined;